import axios from 'axios'
import { LOCAL_STORAGE_JWT_TOKEN } from 'domains/admin/constants'

// Axios Defaults
axios.defaults.headers.common['Content-Type'] = 'application/json'

// API Base URL
axios.defaults.baseURL = process.env.REACT_APP_API_BASE

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem(LOCAL_STORAGE_JWT_TOKEN)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
